import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import io from 'socket.io-client';
import { DEFAULT_SETTINGS } from '../utils/constants';

const GameContext = createContext();

export const useGame = () => {
    const context = useContext(GameContext);
    if (!context) {
        throw new Error('useGame must be used within a GameProvider');
    }
    return context;
};

export const GameProvider = ({ children }) => {
    const [socket, setSocket] = useState(null);
    const [gameStartState, setGameStartState] = useState(false);
    const [settings, setSettings] = useState(DEFAULT_SETTINGS);
    
    // Wrapper to log gameStart changes with stack trace
    const setGameStart = (value) => {
        console.log('[GameContext] setGameStart called with:', value);
        console.trace('[GameContext] Stack trace:');
        setGameStartState(value);
    };
    const gameStart = gameStartState;
    const [player, setPlayer] = useState({
        id: -1,
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
        screenWidth: window.innerWidth,
        screenHeight: window.innerHeight,
        target: { x: window.innerWidth / 2, y: window.innerHeight / 2 },
        name: '',
        massTotal: 0,
        cells: []
    });
    const [game, setGame] = useState({
        width: 0,
        height: 0
    });
    const [screen, setScreen] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const [users, setUsers] = useState([]);
    const [foods, setFoods] = useState([]);
    const [viruses, setViruses] = useState([]);
    const [fireFood, setFireFood] = useState([]);
    const [leaderboard, setLeaderboard] = useState([]);
    const [chatMessages, setChatMessages] = useState([]);
    const [isMobile, setIsMobile] = useState(false);
    const [kicked, setKicked] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    
    const targetRef = useRef({ x: 0, y: 0 });
    const startPingTimeRef = useRef(0);

    useEffect(() => {
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
        setIsMobile(mobile);
    }, []);

    const updateSettings = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    const addChatMessage = (message, type = 'system') => {
        setChatMessages(prev => [...prev.slice(-10), { message, type, timestamp: Date.now() }]);
    };

    const value = {
        socket,
        setSocket,
        gameStart,
        setGameStart,
        settings,
        setSettings,
        updateSettings,
        player,
        setPlayer,
        game,
        setGame,
        screen,
        setScreen,
        users,
        setUsers,
        foods,
        setFoods,
        viruses,
        setViruses,
        fireFood,
        setFireFood,
        leaderboard,
        setLeaderboard,
        chatMessages,
        setChatMessages,
        addChatMessage,
        isMobile,
        kicked,
        setKicked,
        errorMessage,
        setErrorMessage,
        targetRef,
        startPingTimeRef
    };

    return <GameContext.Provider value={value}>{children}</GameContext.Provider>;
};


